<template>
  <div :class="['question', 'question-definition-data', {'opened': showQuestion}]">
    <!-- label -->
    <transition name="fade" mode="out-in">
      <span v-if="getQuestionText() !== ''" class="tooltip-target b3"> {{ getQuestionText() }}<br/><span class="key">{{question.key}}</span></span>
      <span v-else class="tooltip-target b3 empty">{{ getLang('questionText') }}</span>
    </transition>

    <div class="edit-question-wrapper">
      <transition name="fade" mode="out-in">
        <spinner-loading v-if="!preloadDefinitionLoaded && !questionRemoveChecked" class="spinner-loading" size="17" :line-size="1" />
        <div v-else>
          <i v-show="!isEditingQuestion" class="sherpa-icon icon-trash" @click="deleteAliasCall()"></i>
          <i v-show="!isEditingQuestion" class="sherpa-icon icon-editar" @click="enableDisableQuestion"></i>
        </div>
      </transition>
      <transition name="fade" mode="out-in">
        <div v-if="questionDeleteError" class="question-delete-error">
            <i class="sherpa-icon icon-ico_error"></i> {{ deleteErrorText }}
        </div>
      </transition>
    </div>

    <!-- Edit question -->
    <transition name="fade" mode="out-in">
      <div v-if="showQuestion" v-show="!question.forDelete" class="question-definition-data-inner">
        <div class="header">
          <p class="question-key">
            {{ question.key }}
          </p>
          <a class="close" v-on:click="disableQuestion"><i class="sherpa-icon icon-cerrar"></i></a>
          <transition name="fade" mode="out-in">
            <spinner-loading v-if="builderModifyCall" size="17" :line-size="1" class="spinner-loading" />
            <a class="save" v-else @click="saveAliasDefinition()" v-tooltip="{content: getLang('save'), delay: { show: 300, hide: 100 }}"><i class="far fa-save"></i></a>
          </transition>
          <transition name="fade" mode="out-in">
            <spinner-loading v-if="builderDeleteCall" size="17" :line-size="1" class="spinner-loading" />
            <a class="delete" v-else @click="deleteAliasDefinition()" v-tooltip="{content: getLang('delete'), delay: { show: 300, hide: 100 }}"><i class="sherpa-icon icon-trash"></i></a>
          </transition>
        </div>

        <definition-text
          :placeholder="question.value" :definition="question.definition" :object="question.object" :editable="true" :mandatoryValidation="mandatoryValidation" :languageSelected="languageSelected" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :showMultilanguage="false"
          :language="language" :visualDefinition="visualDefinition" :apiparams="apiparams"
          @validateMandatory="validateMandatory"
        />

        <definition-task v-if="question.task && question.task.length > 0"
          :definition="question" :object="question.objectAlias" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams" :embeddedDefinition="question.embeddedDefinition" :builderModifyCall="builderModifyCall" :builderDeleteCall="builderDeleteCall"
          @definitionupdated="definitionupdated" @definitionerror="validatingFormError" @validatingFormError="validatingFormError"
          @refreshDefinition="taskValueChanged" @refreshDefinitionContent="refreshDefinitionContent" @definitionloaded="definitionLoaded" @definitiondeleted="definitiondeleted" @taskLink="taskLink"
        />
        <transition name="fade" mode="out-in">
          <spinner-loading v-if="!questionDefinitionLoaded" size="17" :line-size="1" class="spinner-loading" />
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import DefinitionTask from '../../task'
import DefinitionText from '../../text'
import transport from 'vue-definition-utils/src/utils/transport'
import language from '../../../language'
import moment from 'moment'
import * as api from '../../../utils/api'

export default {
  name: 'definition-builder-question',
  props: [
    'question',
    'language',
    'languageSelected',
    'mandatoryValidation',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'visualDefinition',
    'apiparams',
    'authorization',
    'type',
    'visuals',
    'isEditingQuestion'
  ],
  components: {
    DefinitionText,
    DefinitionTask
  },
  data () {
    return {
      builderModifyCall: null,
      builderDeleteCall: null,
      showQuestion: false,
      questionDefinitionLoaded: false,
      definitionTask: null,
      preloadDefinitionLoaded: false,
      questionRemoveChecked: false,
      questionDeleteError: false,
      deleteErrorText: ''
    }
  },
  mounted () {
    var languageKey = this.getLang()
    if (this.languageSelected) {
      languageKey = this.languageSelected.key
    }
    this.setQuestionDefaultText(this.question.value, this.question.object.languageValue, languageKey)
    this.preloadQuestionDefinition()
  },
  methods: {
    setQuestionDefaultText (text, languageValue, language) {
      var found = false
      if (languageValue) {
        for (var i = 0; i < languageValue.length && !found; i++) {
          if (languageValue[i].key === language) {
            if (languageValue[i].value === '') {
              languageValue[i].value = text
            }

            found = true
          }
        }
      }
    },
    getQuestionText () {
      var languageKey = this.getLang()
      if (this.languageSelected) {
        languageKey = this.languageSelected.key
      }
      return transport.methods.getLanguageValue(this.question.object, languageKey)
    },
    getLang (key) {
      return language(this.language, key)
    },
    saveAliasDefinition () {
      this.question.embeddedDefinition.id = this.definitionContentId
      this.question.embeddedDefinition.code = this.repeatableGroupCode
      this.builderModifyCall = moment().valueOf()
    },
    deleteAliasDefinition () {
      this.question.embeddedDefinition.id = this.definitionContentId
      this.question.embeddedDefinition.code = this.repeatableGroupCode
      this.builderDeleteCall = moment().valueOf()
    },
    validateMandatory (timeEvent, requestObject) {
      this.$emit('validateMandatory', timeEvent, requestObject)
    },
    definitionupdated (object, response) {
      this.question.embeddedDefinition.modifying = false
      this.builderModifyCall = null
    },
    definitiondeleted (object, response) {
      if (response.requestResult) {
        this.$emit('questionDeleted', this.question.key)
      } else {
        this.question.forDelete = false
        this.deleteErrorText = response.requestResultError.requestErrorMsg
        this.questionDeleteError = true
        this.questionRemoveChecked = true
        this.builderDeleteCall = null
        this.disableQuestion()

        var self = this
        setTimeout(function () {
          self.deleteErrorText = ''
          self.questionDeleteError = false
        }, 4000)
      }
    },
    validatingFormError () {
      this.question.embeddedDefinition.modifying = false
      this.builderModifyCall = null
    },
    taskValueChanged (object) {
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    enableDisableQuestion () {
      if (!this.showQuestion) {
        this.questionDefinitionLoaded = false
      }
      this.showQuestion = !this.showQuestion
      this.$emit('editingQuestion', this.showQuestion)
    },
    disableQuestion () {
      this.showQuestion = false
      this.$emit('editingQuestion', this.showQuestion)
    },
    definitionLoaded (content) {
      this.questionDefinitionLoaded = true
      if (this.question.forDelete) {
        this.deleteAliasDefinition()
      } else {
        this.$emit('editingQuestion', this.questionDefinitionLoaded)
      }
    },
    preloadQuestionDefinition () {
      if (this.question.task && this.question.task.length > 0) {
        this.$emit('editingQuestion', true)
        this.definitionTask = this.question.task[0]
        api.call({
          domainEndpoint: this.type.domainEndpoint,
          url: this.definitionTask.type.endpoint,
          token: this.definitionTask.token,
          version: this.definitionTask.version,
          method: 'POST',
          lang: this.getLang(),
          authorization: this.authorization,
          data: {
            id: this.definitionContentId,
            code: this.repeatableGroupCode,
            requestObject: [this.question.objectAlias]
          }
        })
          .then(resp => {
            if (!this.question.forDelete) {
              this.setQuestionLoadedStatus()
            } else {
              this.enableDisableQuestion()
            }
          })
          .catch(err => {
            console.error(err)
            this.$emit('editingQuestion', false)
          })
      }
    },
    setQuestionLoadedStatus () {
      this.preloadDefinitionLoaded = true
      this.questionRemoveChecked = true
      this.$emit('editingQuestion', false)
    },
    deleteAliasCall () {
      this.question.forDelete = true
      this.preloadDefinitionLoaded = false
      this.questionRemoveChecked = false
      this.enableDisableQuestion()
    },
    taskLink (obj) {
      this.$emit('taskLink', obj)
    }
  }
}
</script>

<style lang="scss">
.question {
  .pretty .state label {
    font-size: 13px;
    text-indent: 1.7em;
  }
  .pretty .state label:before {
    top: calc((0% - (100% - 1.25em)) - 35%)!important;
  }
  .pretty.p-bigger .icon,
  .pretty.p-bigger .img,
  .pretty.p-bigger .svg,
  .pretty.p-bigger label:after,
  .pretty.p-bigger label:before {
    top: calc((0% - (100% - 1.25em)) - 35%)!important;
  }

  span.tooltip-target {
    vertical-align: middle;
  }

  .edit-question-wrapper {
    min-width: 40px;
    position: absolute;
    right: 4px;
    top: 2px;

    i {
      cursor: pointer;
      font-size: 17px;
      color: #ff7643;
      vertical-align: sub;
      transition: color 0.2s ease-in;

      &:hover {
        color: #ffbd42;
      }
    }

    .spinner-loading {
      margin-top: 5px;
    }

    .question-delete-error {
      position: absolute;
      top: 41px;
      z-index: 10000000;
      left: 0;
      border-radius: 6px;
      border: 1px dashed #df4444;
      padding: 7px 12px 8px;
      background-color: rgba(255,220,220,1);
      color: #000;
      overflow-wrap: break-word;
      min-width: 275px;
      font-family: Barlow;

      &::before {
        content: '';
        display: block;
        position: absolute;
        right: 39px;
        top: -16px;
        width: 0;
        height: 0;
        border-style: solid;
        border-color: transparent transparent #df4444 transparent;
        border-width: 8px;
      }

      i {
        color: #df4444;
        margin-right: 5px;
      }
    }
  }

  &.opened {
    cursor: default;
  }
}

.question-definition-data {
  &.question {
    .question-definition-data-inner {
      padding: 5px 10px 10px;
      position: fixed;
      width: max-content;
      background-color: #f5f5f5;
      border:1px dashed #c0c0c0;
      border-radius: 6px;
      z-index: 100000;
      left: 282px;
      top: 72px;
      bottom: 60px;
      right: 0;
      max-width: 70%;
      overflow-y: auto;

      .header {
        .question-key {
          padding: 0;
          margin: 5px 10px 10px 0;
          font-family: Capriola;
          color: #4599a4;
          width: calc(100% - 100px);
          display: inline-block;
          font-size: 14px;
        }

        .save, .delete {
          i {
            margin-right: 12px;
          }
        }

        .save {
          i {
            font-size: 20px;
          }
        }

        .delete {
          i {
            font-size: 17px;
          }
        }

        .close, .save, .delete {
          float: right;
          padding-top: 4px;

          i {
            color: #ff7643;
            cursor: pointer;
            transition: color 0.2s ease-in;
            font-size: 15px;

            &:hover {
              color: #FFBD42;
            }
          }
        }

        .spinner-loading {
          float: right;
          margin-top: 2px;
          margin-right: 12px;

          .vue-simple-spinner {
            width: 20px !important;
            height: 20px !important;
          }
        }
      }

      .vue-slider-dot-tooltip-inner {
        background-color: #fff;
        border-color: #555;
      }
    }

    span.empty {
      color: #dedede !important;
    }

    .definition-wrapper.text {
      min-height: 80px;

      .multilanguageText {
        width: 100%;

        .w3-input {
          border: 1px dotted #b5b5b5;
          margin-bottom: 0;
          font-size: 19px;
          font-family: Barlow;
          border-radius: 4px;
          background-color: rgba(255, 255, 255, 0.6);
          padding: 5px 40px 5px 15px;
          width: 100%;
          color: #333;
          outline: none;
        }
        .w3-input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: #dfdfdf;
        }
        .w3-input:-ms-input-placeholder { /* Internet Explorer 10-11 */
          color: #dfdfdf;
        }
        .w3-input::-ms-input-placeholder { /* Microsoft Edge */
          color: #dfdfdf;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/repeatableGroup/definitionBuilder/definitionBuilderQuestion.vue